import React from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	disputeQuoteForBuyer,
	quotesRestCrudThunksForBuyer,
	markQuotePaidForBuyer,
	markQuoteProcessingForBuyer,
	markQuotePendingForBuyer,
} from '../../thunks/quotes_thunks';
import { getEntityById } from '../../utils/DataAccessUtils';
import {
	appendWorkOrderNotesForBuyer,
	workOrdersRestCrudThunksForBuyer,
} from '../../thunks/work_orders_thunks';
import {
	proposalStatusChangeForBuyer,
	syncProposalApprovalHierarchy,
} from '../../thunks/proposals_thunks';
import { markUserNotificationsReadForBuyer } from '../../thunks/user_notifications_thunks';
import QuotePageDisplay from '../quote_page_display/QuotePageDisplay';
import { OscarAskInput } from '../../ai_agent';
import { withOscarContextEnabled } from '../../ai_agent/hooks/withOscarContextEnabled';

const { Content } = Layout;

const style = require('./QuotesDetailDetailsPage.less');
class QuotesDetailDetailsPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
	}

	refreshQuote = () => {
		const { getQuote, match, getWorkOrder } = this.props;
		const { workOrder } = this.props.quote;
		const quoteId = match.params.id;
		return Promise.all([getQuote(quoteId), getWorkOrder(workOrder.id)]);
	};

	componentDidMount() {
		const { match, markUserNotificationsRead } = this.props;
		// The parent QuotesDetailPage owns the single-proposal GET, so this tab only marks the
		// notifications read — fetching here too would duplicate that request on a cold load.
		markUserNotificationsRead(match.params.id);
	}
	componentDidUpdate(prevProps) {
		const { quote, markUserNotificationsRead } = this.props;
		const { quote: prevQuote } = prevProps;
		if (quote && prevQuote && quote.id !== prevQuote.id) {
			markUserNotificationsRead(quote.id);
		}
	}

	render() {
		const { quote, quotesUpdating, currentUser, oscarContextEnabled } = this.props;

		return (
			<Content className="QuoteDetailDetailsPage">
				<QuotePageDisplay
					key={quote.id}
					quote={quote}
					refreshQuote={this.refreshQuote}
					quotesUpdating={quotesUpdating}
					displayComparison={true}
					// Right-aligned at the top of the quote card. Only when it shows: with Oscar off the
					// card keeps its usual layout.
					headerAction={
						oscarContextEnabled ? (
							<OscarAskInput
								placeholder="Ask me anything about this quote"
								className="w-96 max-w-full"
							/>
						) : null
					}
				/>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	quotesFetching: state.proposals.fetching,
	quotesUpdating: state.proposals.updating,
	quote: getEntityById(ownProps.match.params.id, state.proposals),
	quotes: state.proposals,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
	workOrder: state.work_orders.detail,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch) => ({
	appendWorkOrderNotes: (entity) => dispatch(appendWorkOrderNotesForBuyer(entity)),
	updateQuote: (entity) => dispatch(quotesRestCrudThunksForBuyer.update(entity)),
	getQuote: (id) => dispatch(quotesRestCrudThunksForBuyer.readOne(id)),
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForBuyer.readOne(id)),
	approveQuote: (entity) => dispatch(proposalStatusChangeForBuyer('awarded', entity)),
	declineQuote: (entity) => dispatch(proposalStatusChangeForBuyer('declined', entity)),
	syncQuote: (entity) => dispatch(syncProposalApprovalHierarchy(entity)),
	markQuoteProcessing: (id) => dispatch(markQuoteProcessingForBuyer({ id })),
	markQuotePending: (id) => dispatch(markQuotePendingForBuyer({ id })),
	markQuotePaid: (id) => dispatch(markQuotePaidForBuyer({ id })),
	disputeQuote: (id) => dispatch(disputeQuoteForBuyer({ id })),
	markUserNotificationsRead: (entityId) =>
		dispatch(markUserNotificationsReadForBuyer('Quote', entityId)),
});

export default withOscarContextEnabled(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(QuotesDetailDetailsPage))
);
